/**
 * @generated SignedSource<<f18a676722807b1fb0a5d0c672634eb6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareAccessAccountDrawerRevokeMutation$variables = {
  id: string;
};
export type ShareAccessAccountDrawerRevokeMutation$data = {
  readonly lockUtilizationGrantDeactivate: {
    readonly deactivatedAt: any | null | undefined;
    readonly id: string;
  };
};
export type ShareAccessAccountDrawerRevokeMutation = {
  response: ShareAccessAccountDrawerRevokeMutation$data;
  variables: ShareAccessAccountDrawerRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantDeactivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deactivatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessAccountDrawerRevokeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessAccountDrawerRevokeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b75fc293894fccddbc97fe00ffb84f52",
    "id": null,
    "metadata": {},
    "name": "ShareAccessAccountDrawerRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation ShareAccessAccountDrawerRevokeMutation(\n  $id: UUID!\n) {\n  lockUtilizationGrantDeactivate(id: $id) {\n    id\n    deactivatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a09e5ee0b8f0760f00ce79d73cb8876";

export default node;
